import { store, deleteUserAccountInfo } from "@redux"
import { userLogoutRefreshToken } from "services"

const logout = () => {
  userLogoutRefreshToken()

  localStorage.removeItem("at")
  localStorage.removeItem("rt")

  store.dispatch(deleteUserAccountInfo())
}

export default logout